import React from 'react';
import { NumberService, RoleService } from 'Services';
import useEditList from 'Hooks/query-hooks/list/useEditList';
import EditListOverviewModal from '../EditListOverviewModal';
import LinkedRulesCount from '../LinkedRulesCount';

type GenOverview = { id: string; label: string; data: string | number | React.ReactNode; noEllipsis?: boolean };

export const genOverview = (apiData: ListManagementApiList, t: (s: String) => string): GenOverview[] => [
    {
        id: 'listEntries',
        label: t('List Entries'),
        data: NumberService.getLocaleNumber(Number(apiData?.activeListEntriesCount) || 0)
    },
    {
        id: 'listType',
        label: t('List Type'),
        data: apiData?._formatted?.listType
    },
    {
        id: 'linkedRules',
        label: t('Linked Rules'),
        data: <LinkedRulesCount sandboxRules={apiData.sandboxRules} deployedRules={apiData.deployedRules} />,
        noEllipsis: true
    },
    {
        id: 'description',
        label: t('Description'),
        data: apiData?.description
    }
];
type EditListOverviewProps = {
    modalStatus: boolean;
    data: any;
    showModal: (listActionModalStatus: boolean) => void;
};
const EditListOverview = ({ modalStatus, data, showModal }: EditListOverviewProps) => {
    const isListAdmin = RoleService.isListAdmin();
    const mutation = useEditList(data?.id, {
        mutationOptions: {
            onSuccess: () => {
                showModal(false);
            }
        }
    });

    return (
        <>
            {isListAdmin && (
                <EditListOverviewModal
                    isLoading={mutation.isLoading}
                    isOpen={modalStatus}
                    onClose={() => showModal(false)}
                    overview={data}
                    onSave={(values: PatchList) => mutation.mutate(values)}
                    error={mutation.error}
                    resetError={mutation.reset}
                />
            )}
        </>
    );
};

export default EditListOverview;
